import { Injectable } from '@angular/core'
import { CollectionRepository } from '@engineering11/web-api-firebase'
import { COLLECTIONS } from '@engineering11/commerce-web'
import { ICompleteProductItem } from '../model/product-item.model'

@Injectable({ providedIn: 'root' })
export class ProductItemRepository extends CollectionRepository<ICompleteProductItem> {
  protected COLLECTION = COLLECTIONS.PURCHASABLE_ITEM
}
